import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  formerTodoDropdown: {
    backgroundColor: palette.shades[200],
    border: "1px solid ".concat(palette.shades[300]),
    '&:hover': {
      backgroundColor: palette.shades[300]
    }
  }
});
export default useStyles;